import React from 'react';
import { IconProps } from '.';

const SvgBoxTaped = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22 2v20H2V2h20Zm-7 1.5h5.5v17h-17v-17H9V11h6V3.5Zm-1.5 0h-3v6h3v-6Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxTaped;
